import { Command } from '@ckeditor/ckeditor5-core';

export default class ResizeRecorderCommand extends Command {
    refresh() {
        const editor = this.editor;
        const recorderUtils = editor.plugins.get('RecorderUtils');
        const element = recorderUtils.getClosestSelectedRecorderElement(
            editor.model.document.selection
        );

        this.isEnabled = !!element;

        if (!element || !element.hasAttribute('width')) {
            this.value = { width: 'Original', height: null };
        } else {
            this.value = {
                width: element.getAttribute('width'),
                height: null
            };
        }
    }

    execute(options) {
        const editor = this.editor;
        const model = editor.model;
        const recorderUtils = editor.plugins.get('RecorderUtils');

        const recorderElement = recorderUtils.getClosestSelectedRecorderElement(
            model.document.selection
        );

        if (!recorderElement) return;

        const unit = editor.config.get('recorder.resizeUnit') || '%';

        // Si no hay width (Original), guardamos "auto"
        let value;
        if (!options.width || options.width === 'original') {
            value = 'Original';
        } else {
            value = options.width + unit;
        }

        this.value = {
            width: value,
            height: null
        };

        model.change(writer => {
            writer.setAttribute('width', value, recorderElement);
        });
    }
}
